export default __webpack_public_path__ + "static/media/terror-vision.a6e555c3.jpg";